import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  console.warn('[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY — form submissions will fail.')
}

export const supabase = createClient(url ?? '', anonKey ?? '')

function context() {
  return {
    user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    referrer: typeof document !== 'undefined' ? document.referrer || null : null,
  }
}

export async function submitIndividualSignup(payload) {
  const { error } = await supabase
    .from('maysocourse_individual')
    .insert({ ...payload, ...context() })
  if (error) throw error
}

export async function submitNgoSignup(payload) {
  const { error } = await supabase
    .from('maysocourse_ngo')
    .insert({ ...payload, ...context() })
  if (error) throw error
}
